import { useCallback, useEffect, useRef } from "react";
import { useForm } from "react-hook-form";
import { Link, useNavigate, useParams, useSearchParams } from "react-router-dom";
import { useAuth } from "_hooks";
import { useOnBoardingGs1 } from "partner/_hooks";
import { setLogin } from "_config/store/account/slices";
import { InputControl } from "components/organism";
import { Button, Hr } from "components/atoms";
import { WEB_APP } from "_config/constants/app.constants";
import { yupResolver } from "@hookform/resolvers/yup";
import { loginSchema } from "_config/formSchemas";
import { useAuth0 } from "@auth0/auth0-react";

const prefix = "vv-login";

const Login = () => {
  const { login: onSubmit, user, isLoggedIn } = useAuth();
  const { isAuthenticated } = useAuth0();
  const { register, handleSubmit, formState: { errors } } = useForm({
    resolver: yupResolver(loginSchema)
  });
  const navigate = useNavigate();
  const { lookAndFeel, logoutAuth0 } = useOnBoardingGs1();
  const { partner } = useParams();
  const initialized = useRef();
  const [searchParams] = useSearchParams();

  const checkIt = useCallback(() => {
    if (searchParams?.get("callback") === "logout") {
      if (isAuthenticated) {
        try {
          logoutAuth0(partner);
        } catch(e) {}
      }
    } else {
      if (!initialized?.current) {
        initialized.current = true;
        isLoggedIn();
      }
    }
  }, [isAuthenticated, isLoggedIn, logoutAuth0, partner, searchParams]); 


  useEffect(() => {
    return () => {
      setLogin();
    };
  }, []);

  useEffect(() => {
    checkIt();
  }, [checkIt]);

  useEffect(() => {
    checkIt();
  }, [checkIt]);

  useEffect(() => {
    if (user !== null) {
      window.location.replace(WEB_APP);
    }
  }, [user]);
  
  return (
    <div className={`${prefix} h-full flex flex-col justify-center text-center`}>
      <div className="flex flex-wrap flex-col gap-3">
        {lookAndFeel?.logo &&
          <img src={lookAndFeel.logo?.src} alt="nbsk-logo" className="w-[90%] max-h-[100px] max-w-[500px] mx-auto mb-3"/>
        }
        <p className="text-center text-3xl font-bold mx-auto">Inicia sesión</p>
        <p className="text-center text-xl mx-auto mb-5">Nos da gusto verte de nuevo</p>
        
        <Button
          className="rounded-lg flex flex-column justify-left align-center border-2"
          onClick={() => navigate(`/partner/${partner}/auth0`)}
          style={{
            color: lookAndFeel.secondary.solid,
            border: `1px solid ${lookAndFeel?.secondary?.solid}`
          }}
        >
          <img src={lookAndFeel?.logo?.gs1} alt="" className="max-h-[25px]" />
          <span>Inicia sesión con GS1 MX</span>
        </Button>
        <Hr content="Ó" />
        <form 
          className="flex flex-wrap flex-col gap-5"
          onSubmit={handleSubmit(onSubmit)}
        >
          <InputControl
            errors={errors?.email}
            label="Correo electrónico"
            orientation="vertical"
            inputProps={{
              autoComplete: "off",
              placeholder: "Ej. nombre@tuempresa.com",
              ...register("email")}
            }
          />

          <InputControl
            errors={errors?.password}
            label="Contraseña"
            orientation="vertical"
            inputProps={{
              autoComplete: "off",
              placeholder: "****",
              type: "password",
              ...register("password")
            }}
          />
          
          <span className="text-gray-800 w-full text-right">
            <Link to={`/partner/${partner}/forgot`} className="underline">Olvidé mi contraseña</Link>
          </span>
          
          <Button
            className="text-white rounded-lg"
            fullwidth
            pulse
            style={{
              backgroundColor: lookAndFeel?.primary?.solid,
              color: lookAndFeel?.primary?.text
            }}
            type="submit"
          >Continuar</Button>
        </form>
      </div>
    </div>
  );
};

export default Login;
